/* src/app/login/login.component.css */
.screenPos {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .screenPos {
    margin-top: -51%;
  }
}
.cardPos {
  width: 100rem;
  margin-bottom: 10%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .cardPos {
    width: 100rem;
    margin-top: 4rem;
  }
}
.theSpace {
  margin-bottom: 30px;
}
/*# sourceMappingURL=login.component.css.map */
